import type { ResponsiveProp } from "../types";
import { useWindowSize } from "../context/WindowSize";
import { maxPhoneWidth, maxTabletWidth } from "../utils/css/mediaQueries";
import { normaliseResponsiveProp } from "../utils/responsiveProps";

export default function useResponsiveProp<T>(prop: ResponsiveProp<T>): T {
  const { width } = useWindowSize();

  const normalised = normaliseResponsiveProp(prop);

  return normalised[getIndexFromWidth(width)];
}

const getIndexFromWidth = (width: number) => {
  if (width <= maxPhoneWidth) {
    return 0;
  }

  if (width <= maxTabletWidth) {
    return 1;
  }

  return 2;
};
